import { setSecondaryModalContentOf, updateSecondaryModalVisibility } from 'store/slices/ModalSlice';
import store from 'store/store';

export default class MarkerUtils {
  static handleSecondaryPointClick(contentId: string) {
    store.dispatch(setSecondaryModalContentOf(contentId));
    store.dispatch(updateSecondaryModalVisibility(true));
  }
}
